// Public browser-facing CMS origin, not the CMS server's internal bind address.
// Set REACT_APP_CONTENT_ADMIN_ORIGIN per environment before starting/building CRA.
// Remote HTTPS platforms must use the CMS's remote HTTPS origin; no localhost fallback.
export const ContentAdminConfig = {
	url: process.env.REACT_APP_CONTENT_ADMIN_ORIGIN || ''
}
